export enum CatalogIndustryTypeEnum {
  CASINO = 'casino',
  SPORTS = 'sports',
}
